// alternative-dashboard/TreasuryDashboard.tsx
import AlternativeBalanceOverview from "./alternative-components/AlternativeBalanceOverview";
import AlternativeInfoCarousel from "./alternative-components/AlternativeInfoCarousel";
import { mockInfoCarouselItems } from "./mockdata/dashboardMockData";
import DashboardWidgetRenderer from "./DashboardWidgetRenderer";
import {
  TREASURY_WIDGET_REGISTRY,
  TREASURY_BALANCE_OVERVIEW_MENU_IDS,
} from "./dashboardWidgetRegistryConfig/treasuryWidgetRegistry.config";
import SubmitLoading from "@/app/components/webloading/errorHandling/SubmitLoading";
import { useDashboardLayoutData } from "./types/useDashboardLayoutData";
import "./alternative-components/styles/AlternativStyle.scss";
import {
  TREASURY_WIDGET_LAYOUT,
  type TreasuryWidgetLayout,
} from "./dashboardWidgetRegistryConfig/treasuryLayout.config";
import { useSelector } from "react-redux";
import type { RootState } from "@/app/redux/store";

function TreasuryDashboard() {
  const { menuDetail, loading } = useDashboardLayoutData();

  const tenantId = useSelector(
    (state: RootState) => state.userData?.data?.tenantId,
  );

  if (!tenantId || loading) {
    return (
      <div className="gx-bene-form-container-loading-overlay">
        <SubmitLoading />
      </div>
    );
  }

  const showBalanceOverview = menuDetail.some(
    (m: { recordState: string; menuId: number }) =>
      TREASURY_BALANCE_OVERVIEW_MENU_IDS.has(m.menuId) && m.recordState === "A",
  );

  const remainingMenus = menuDetail.filter(
    (m: { menuId: number }) =>
      !TREASURY_BALANCE_OVERVIEW_MENU_IDS.has(m.menuId),
  );

  const menuMap = new Map(
    remainingMenus.map((menu: any) => [menu.menuId, menu]),
  );

  const rows: {
    type: "half" | "full";
    widgets: any[];
  }[] = [];

  for (let i = 0; i < TREASURY_WIDGET_LAYOUT.length; ) {
    const current: TreasuryWidgetLayout = TREASURY_WIDGET_LAYOUT[i];

    if (current.size === "half") {
      const next = TREASURY_WIDGET_LAYOUT[i + 1];

      rows.push({
        type: "half",
        widgets: [
          menuMap.get(current.menuId),
          next ? menuMap.get(next.menuId) : undefined,
        ].filter(Boolean),
      });

      i += 2;
    } else {
      rows.push({
        type: "full",
        widgets: [menuMap.get(current.menuId)].filter(Boolean),
      });

      i++;
    }
  }

  return (
    <div className="gx-alter-main-container">
      {showBalanceOverview && <AlternativeBalanceOverview />}

      <AlternativeInfoCarousel items={mockInfoCarouselItems} />

      {rows.map((row, index) => {
        if (row.widgets.length === 0) return null;

        return (
          <div key={index} className={`gx-alter-row gx-alter-row--${row.type}`}>
            {row.widgets.map((menu: any) => (
              <DashboardWidgetRenderer
                key={menu.menuId}
                menuDetail={[menu]}
                registry={TREASURY_WIDGET_REGISTRY}
                extraProps={{
                  204: {
                    variant: "dashboard",
                  },
                }}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
}

export default TreasuryDashboard;
